import React from 'react';
import TestimonialsCarousel from './TestimonialsCarousel';

const ThankfulForTransparency = () => {
  return (
    <section className="py-5" style={{backgroundColor: "var(--tu-primary-yellow)"}}>
        <div className="container-fluid px-5">
            <div className="text-center">
                <div className="display-5 fw-bold mb-4 thankful-for-transparency-header" style={{color: "var(--tu-primary-black)"}}>
                    Thankful For Transparency
                </div>
                <p className="lead mb-4" style={{color: "var(--tu-primary-black)"}}>
                    We're grateful for the opportunity to serve the people of Utah by providing 
                    transparent access to government data and promoting accountability in public spending. 
                    This November, elected officials and state leaders join Transparent Utah in celebrating 
                    why we're all #ThankfulForTransparency.
                </p>
                
                {/* Testimonials Carousel Section */}
                <TestimonialsCarousel />
            </div>
        </div>
    </section>
  )
}
 
export default ThankfulForTransparency